<template>
    <Link as="button"
          class="btn btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bold px-5"
          :class="{'disabled': disabled}"
          :href="href"
          @click="preventReturningWithoutSaving"
    >
        <i class="color-inherit" :class="[icon]"/>
        {{ __('actions.back_to') }}
        {{ to }}
    </Link>
</template>

<script>
import {Link} from '@inertiajs/vue2';

export default {
    components: {Link},

    props: {
        icon: {
            type: String,
            default: 'fas fa-chevron-circle-left'
        },
        to: {
            type: String,
            default() {
                return __('navigation.previous_page').lcfirst();
            }
        },
        href: {
            type: String,
            default() {
                return this.$page.props.previous_url
            }
        },
        disabled: Boolean,
        preventLeave: Boolean,
        preventLeaveText: {
            type: String,
            default: 'Discard unsaved changes?'
        }
    },

    methods: {
        preventReturningWithoutSaving() {
            if (this.disabled) {
                event.preventDefault();
                return
            }

            if (this.preventLeave) {
                let vue = this;
                Swal.fire({
                    title: this.preventLeaveText,
                    text: 'You are about to cancel.',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-danger m-0',
                    confirmButtonText: 'Yes, abort.',
                    cancelButtonText: 'Continue',
                }).then(function (result) {
                    if (result.value) {
                        vue.$inertia.visit(vue.href);
                    }
                });

                event.preventDefault();
            }
        }
    }
}
</script>
